import { Dispatch, FunctionComponent } from 'react';
import { VoucherCheckoutState } from '../../../vouchersState';

import styles from './styles.module.scss';
import classNames from 'classnames';
import Image from 'next/image';
import { EmailField, Field, FieldContainer, Input } from '@cademy-ui/form';

export const SharingMethodSelector: FunctionComponent<{
    state: VoucherCheckoutState;
    dispatch: Dispatch<Partial<VoucherCheckoutState>>;
}> = ({ state, dispatch }) => {
    return (
        <div>
            <Field<'email' | 'pdf'> name="sharingMethod">
                {({ value, setValue }) => {
                    return (
                        <div className={styles.sharingSelectorContainer}>
                            <label
                                htmlFor="email"
                                className={classNames(styles.sharing_card, {
                                    [`${styles.sharing_card_selected}`]: value === 'email',
                                })}
                            >
                                <input
                                    type="radio"
                                    id="email"
                                    value="email"
                                    className={styles.sharing_card_input}
                                    onChange={() => setValue('email')}
                                    checked={value === 'email'}
                                />
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/icons/at-duotone-blue.svg`}
                                    alt="Email sharing method icon"
                                    height={20}
                                    width={20}
                                />
                                <span className={styles.sharing_card_label}>Email</span>
                            </label>
                            <label
                                htmlFor="pdf"
                                className={classNames(styles.sharing_card, {
                                    [`${styles.sharing_card_selected}`]: value === 'pdf',
                                })}
                            >
                                <input
                                    type="radio"
                                    id="pdf"
                                    value="pdf"
                                    className={styles.sharing_card_input}
                                    onChange={() => setValue('pdf')}
                                    checked={value === 'pdf'}
                                />
                                <Image
                                    src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/icons/file-pdf-duotone-blue.svg`}
                                    alt="PDF sharing method icon"
                                    height={20}
                                    width={20}
                                />
                                <span className={styles.sharing_card_label}>PDF</span>
                            </label>
                        </div>
                    );
                }}
            </Field>
            {state.sharingMethod === 'email' ? (
                <>
                    <EmailField
                        name="recipientEmail"
                        label="Recipient Email"
                        description="The voucher will be emailed to this address."
                        required
                    />
                    <span className={styles.sharingMethodDescription}>
                        The voucher will be emailed once the purchase is complete.
                    </span>
                </>
            ) : null}
            {state.sharingMethod === 'pdf' ? (
                <span className={styles.sharingMethodDescription}>
                    You will be able to print the voucher once you complete the purchase.
                </span>
            ) : null}
        </div>
    );
};
